import { PreviouslySelectedOptionsForWidgets } from '../../../../reducers/student/tracking/questionWidgetTrackingReducer';
import { IPersistenceTrackingClient, PersistenceTrackingData, TrackingDataVersion } from '../trackingClient';
import { TrackingIdentifier } from '@ael/core-api';
import { Map, Set } from 'immutable';

export class NullClient implements IPersistenceTrackingClient {
  _finishedItems: Set<string>;
  constructor() {
    this._finishedItems = Set<string>();
  }

  name = 'inMemoryStorageClient';
  doesSupportLegacyData = false;

  init(): Promise<boolean> {
    return Promise.resolve(true);
  }

  getTrackingData(): Promise<PersistenceTrackingData> {
    return Promise.resolve({
      finishedItems: Set<TrackingIdentifier>(),
      widgetTrackingData: Map<TrackingIdentifier, PreviouslySelectedOptionsForWidgets>(),
      version: TrackingDataVersion.v2,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTrackingData(_: PersistenceTrackingData): Promise<void> {
    return Promise.resolve();
  }

  setCompletionStatus = () => {
    return Promise.resolve();
  };

  afterSetup(): Promise<void> {
    return Promise.resolve(undefined);
  }

  setQuizStatus = (): Promise<void> => {
    return Promise.resolve();
  };
}
